import {
  usePostApiAdminByStudentIdMasqueradeMutation,
  usePostApiAdminClearMasqueradingMutation,
} from 'shared/api/gsp';
import { MutationCacheKey } from 'shared/constants/mutation';

export const useMasqueradeLoading = () => {
  const [, { isLoading: observeLoading }] =
    usePostApiAdminByStudentIdMasqueradeMutation({
      fixedCacheKey: MutationCacheKey.ObserveStudent,
    });
  const [, { isLoading: unObserveLoading }] =
    usePostApiAdminClearMasqueradingMutation({
      fixedCacheKey: MutationCacheKey.UnObserveStudent,
    });

  return observeLoading || unObserveLoading;
};
